import { Divider, IconButton } from '@material-ui/core';
import DeleteIcon from '@material-ui/icons/Delete';
import { Field } from 'formik';
import { TextField } from 'formik-material-ui';
import React, { useContext } from 'react';
import styled from 'styled-components';
import FormikButtonsControl from '../common/FormikButtonsControl';
import EditIcon from '@material-ui/icons/Edit';
import CheckIcon from '@material-ui/icons/Check';
import FunctionsContext from './FunctionsContext'

const EditIconContainer = styled.div`
    padding-left:10px;
    padding-right:10px;
`;

const OuterContainer = styled.div`
    width:100%
    &:hover {
        background:#E8E8E8;
    }    
    &:not(:hover) ${EditIconContainer} {
        display: none;
      }    
`;

const Container = styled.div`
    width:100%
    padding-left:20px;
    padding-right:20px;
    display:grid;
    grid-template-columns:1fr 1fr;
    align-items:center;
    height:60px; 
`;

const SubContainerA = styled.div`
display:flex;
flex-direction:column;
justify-content:center; 
`;

const SubContainerA1 = styled.div`
text-align: left;
font-size: 15px;
font-weight:500;
font-family: "Roboto", "Helvetica", "Arial", sans-serif;
`;

const SubContainerA2 = styled.div`
text-align: left;
font-size:13px
font-family: "Roboto", "Helvetica", "Arial", sans-serif;
font-weight:400; 
`;


const SubContainerB = styled.div`
      display:flex;
      align-items:center;
      justify-content:space-between;
      height:60px;
      padding-left:60px;
`;


const CorpContainer = styled.div`
text-align: left;
font-size: 15px;
font-weight:500;
font-family: "Roboto", "Helvetica", "Arial", sans-serif;
color:#304a57;
display:flex;
align-items:center;
`;


const Type = styled.div`
`;

const DeleteStep = styled.div`
    font-size:24px;
`;

const CategoryItem = ({ arrayHelpers, index, formProps, context }) => {
    const functionscontext = useContext(FunctionsContext)
    const currentUser = context.aboutCurrentUser;
    const currentGBUAdminGBUs = currentUser.permissions.filter(x => x.hasRole === true && x.scope === 'GBU' && x.assetId).map(t => t.assetId);
    const currentOmFunctions = currentUser.permissions.filter(x => x.hasRole === true && x.scope === 'FUNC' && x.assetId).map(t => t.assetId);
    const canCurrentUserEditCategories = ((currentUser.isOM && currentOmFunctions.some(x => x === functionscontext.functions.selectedFunction.id)) || currentUser.isAdmin) || (currentUser.isGbuAdmin && !formProps.values.categories[index].isCorporate && (currentGBUAdminGBUs.some(x => x === formProps.values.categories[index].gbuid) || formProps.values.categories[index].gbuid === 0));
    if (formProps.values.categories[index].delete) {
        return null;
    }

    return (
        <OuterContainer>
            <Container key={index}>
                <SubContainerA>
                    <SubContainerA1>
                        {formProps.values.categories[index].name}
                    </SubContainerA1>
                    <SubContainerA2>
                        {formProps.values.categories[index].description}
                    </SubContainerA2>
                </SubContainerA>
                <SubContainerB>
                    <CorpContainer>
                        {formProps.values.categories[index].isCorporate &&
                            <>
                                <CheckIcon color="primary" />
                                <div style={{ paddingLeft: 10 }}>Corporate</div>
                            </>
                        }
                        {(Number(formProps.values.categories[index].gbuid && formProps.values.categories[index].gbuid) > 0) && functionscontext.functions.gbus &&
                            <>
                                <CheckIcon color="primary" />
                                <div style={{ paddingLeft: 10 }}>GBU({functionscontext.functions.gbus.find(x => x.id === formProps.values.categories[index].gbuid).name})</div>
                            </>
                        }
                    </CorpContainer>
                    {canCurrentUserEditCategories && <EditIconContainer>
                        <IconButton color='primary' onClick={() => { formProps.setFieldValue(`editableIndex`, index) }}>
                            <EditIcon />
                        </IconButton>
                    </EditIconContainer>}
                </SubContainerB>
                <div style={{ paddingTop: 1 }} />
            </Container>
            <Divider />
        </OuterContainer>
    )
}
export default CategoryItem;